import React from "react";
import {
  FaFacebookF,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaBook,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container footer-grid">
          
          {/* Teléfonos */}
          <div className="footer-col">
            <h5>| Teléfonos</h5>
            <ul>
              <li>
                <FaPhoneAlt /> Central Telefónica: <strong>01 500 6177</strong>
              </li>
             
            </ul>
          </div>

          {/*  Redes sociales */}
          <div className="footer-col">
            <h5>| Redes Sociales</h5>
            <ul>
              <li>
                <a
                  href="https://www.facebook.com/iestpjuanvelascoalvarado"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaFacebookF /> Facebook
                </a>
              </li>
              <li>
                <a
                  href="https://www.reclamos.gob.pe/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaBook /> Libro de Reclamaciones
                </a>
              </li>
            </ul>
          </div>

          {/*  Programas de Estudio */}
          <div className="footer-col">
            <h5>| Programas de Estudio</h5>
            <ul>
              <li><Link to="/programas/arquitectura">Arquitectura de Plataforma STI</Link></li>
              <li><Link to="/programas/contabilidad">Contabilidad</Link></li>
              <li><Link to="/programas/enfermeria">Enfermería Técnica</Link></li>
              <li><Link to="/programas/farmacia-tecnica">Técnica en Farmacia</Link></li>
              <li><Link to="/programas/mecatronica-automotriz">Mecatrónica Automotriz</Link></li>
            </ul>
          </div>

          {/* Correos */}
          <div className="footer-col">
            <h5>| Correos</h5>
            <ul>
              <li>
                <FaEnvelope /> secretaria.academica@iestpjva.edu.pe
              </li>
             
            </ul>
          </div>

          {/*  Dirección */}
          <div className="footer-col">
            <h5>| Dirección</h5>
            <ul>
              <li>Instituto de Educación Superior Tecnológico Público</li>
              <li>
                <FaMapMarkerAlt /> Av. José Olaya N° 120<br />
                San Gabriel – Villa María del Triunfo<br />
                Lima – Perú
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Línea inferior */}
      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} IESTP “Juan Velasco Alvarado” — Todos los
          derechos reservados.
        </p>
      </div>
    </footer>
  );
}
